import { useField } from "formik";

import {
  CheckboxProps,
  Checkbox,
} from "../components/inputs/checkbox/Checkbox";

export interface CheckboxFormikFieldProps extends CheckboxProps {
  name: string;
}

export function CheckboxFormikField(props: CheckboxFormikFieldProps) {
  const [field, meta, helpers] = useField(props.name);

  return (
    <Checkbox
      value={props.value}
      isCard={props.isCard}
      className={props.className}
      description={props.description}
      name={props.name}
      isSelected={field.value}
      isDisabled={props.isDisabled}
      isRequired={props.isRequired}
      isInvalid={Boolean(meta.touched && meta.error)}
      errors={meta.touched ? meta.error : undefined}
      children={props.children}
      testID={props.testID}
      validationBehavior="aria"
      noBorder={props.noBorder}
      onChange={(value: boolean) => {
        helpers.setValue(value);
        props.onChange?.(value);
      }}
    />
  );
}
